<template>
    <div id="app" :class="pageClasses">
        <router-view></router-view>
    </div>
</template>

<script>
    /**
     * Component Dependencies
     */
    import { mapGetters, mapActions } from 'vuex'
    import { removeAuthorizationHeader } from './services/HttpService'

    /**
     * Base Application Component
     */
    export default {
        name: 'app',
        methods: {
            ...mapActions([
                'resetApplicationState'
            ])
        },
        watch: {
            isLoggedIn (loggedIn) {
                if (loggedIn === false) {
                    removeAuthorizationHeader()
                    this.resetApplicationState()
                        .then(this.$router.push({
                            name: 'login'
                        }))
                }
            }
        },
        computed: {
            ...mapGetters('user', [
                'isLoggedIn'
            ]),
            pageClasses () {
                return `page--${this.$route.name}`
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/App.vue